if (!customElements.get('carpet-personalization')) {
  customElements.define(
    'carpet-personalization',
    class CarpetPersonalization extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('.carpet-personalization__toggle');
        this.fields = this.querySelector('.carpet-personalization__fields');
        this.conditionalInputs = Array.from(this.fields?.querySelectorAll('input, select') || []);

        if (!this.toggle || !this.fields) return;

        this.toggle.addEventListener('change', () => this.sync());
        this.sync();
      }

      get active() {
        return Boolean(this.toggle?.checked && this.surchargeVariantId);
      }

      get surchargeVariantId() {
        return this.dataset.surchargeVariantId || '';
      }

      validate() {
        if (!this.active) return true;

        const invalidInput = this.conditionalInputs.find((input) => !input.checkValidity());
        if (!invalidInput) return true;

        invalidInput.reportValidity();
        invalidInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      }

      sync() {
        const active = this.toggle.checked;
        this.fields.hidden = !active;
        this.toggle.setAttribute('aria-expanded', String(active));
        this.conditionalInputs.forEach((input) => {
          input.disabled = !active;
        });
      }
    }
  );
}
